import type { SectionExcelLayout } from "../types";

export function selectExcelLayoutTemplateFields(layout: SectionExcelLayout) {
    const { templateId, templateName, templateNameTouched, sourceTemplateName, sourceTemplateIsGlobal, saveAsTemplate, templateSaveMode, title, blockOrder, ...definition } = layout;
    return definition;
}
